import { IJsonQuery } from '@cian/api-models/common/json_query';
import { ca } from '@cian/analytics';

export function trackListingClick(jsonQuery: IJsonQuery) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'Map',
    label: 'ListView',
    sc: jsonQuery,
  });
}
